import React from 'react';
import { DownloadIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy border-t border-white/10" data-id="element-104" data-mp="3gfsja2r5qci8">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-105" data-mp="3ghc0bvkn0rl2">
        <div className="flex items-center gap-3" data-id="element-106" data-mp="36p6aardy4k8i">
          <span className="flex h-9 w-9 items-center justify-center border border-gold text-gold font-serif text-base" data-id="element-107" data-mp="36ppk1ktg02bg">
            SM
          </span>
          <div data-id="element-108" data-mp="3991omvfnkca">
            <p className="font-serif text-base text-white" data-id="element-109" data-mp="37o5ytxdtvcu">Stephanie Meyer</p>
            <p className="text-xs text-slate-500" data-id="element-110" data-mp="3levgx24t5gg6">Total Media Solutions</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-6" data-id="element-111" data-mp="3qcx9qes1cu4u">
          <a href="#" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-gold transition-colors duration-200" data-id="element-112" data-mp="3qfjhaeexf9n2">
            <DownloadIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-113" data-mp="2ezuv3p9hyenb" />
            Download Board Resume (PDF)
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-gold transition-colors duration-200" data-id="element-114" data-mp="3lbmt1p3mp2eb">
            <LinkedinIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-115" data-mp="3q7lmvs7q7cm4" />
            LinkedIn Profile
          </a>
        </div>

        <p className="text-xs text-slate-500" data-id="element-116" data-mp="81fq3xcm4u4q">© {new Date().getFullYear()} Stephanie Meyer. All rights reserved.</p>
      </div>
    </footer>;
}